export class Category {
  constructor(
    technicalId,
    boomerangId,
    name,
    manufacturerId,
    isProspectCategory,
    prospectFolderPictureMandatory,
    prospectCategoryPicture,
    prospectCategoryDescription
  ) {
    this.technicalId = technicalId
    this.boomerangId = boomerangId
    this.name = name
    this.manufacturerId = manufacturerId
    this.isProspectCategory = isProspectCategory
    this.prospectFolderPictureMandatory = prospectFolderPictureMandatory
    this.prospectCategoryPicture = prospectCategoryPicture
    this.prospectCategoryDescription = prospectCategoryDescription
  }
}
